/* tslint:disable */
export var icon = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"15\" height=\"3\"><path fill-rule=\"evenodd\" d=\"M1.5 3a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm6 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm6 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3z\"/></svg>\n";
//# sourceMappingURL=dots.svg.js.map